define([
	"dojo/_base/declare",
	"csi/constants",
	"csi/middleware/customView/customViewDataManagementService",
	"csi/prefs/PreferenceView",
	"src/c8-platform/type/customView",
], function(declare, constants, { migrateGalleryViewGroupSettingsV1 }, PreferenceView, { CustomViewVersion }) {

	return declare(PreferenceView, {
		customOptions: [
			{name: "attributeKeys", personalized: true, value: []},
			{name: "disableAdHoc", value: false},
			{name: "filterRemember", personalized: true, value: true},
			{name: "filterSettings", value: {}},
			{name: "galleryAttributeWidth", formerName: "GalleryAttributeWidth", value: 0},
			{name: "galleryImageHeight", formerName: "GalleryImageHeight", value: 0},
			{name: "galleryImageLabel", formerName: "GalleryImageLabel", value: ""},
			{name: "galleryImageWidth", formerName: "GalleryImageWidth", value: 0},
			{name: "galleryRowsPerPage", formerName: "GalleryRowsPerPage", value: 0},
			{name: "galleryTemplate", formerName: "GalleryTemplate", value: constants.PREFERENCE_DEFAULT},
			{name: "groupHeaderStyle", formerName: "PlotGroupHeaders", value: ""},
			{name: "groupHeaderWidth", formerName: "PlotHeaderWidth", value: 0},
			{name: "groupItemsPerRow", formerName: "PlotItemsPerRow", value: 0},
			{name: "groupSettings", value: {}},
			{name: "hiddenKeys", personalized: true, value: []},
			{name: "imageSize", formerName: "ImageSize", value: ""},
			{name: "printComments", omitFromPreview: true, value: false},
			{name: "printHeader", omitFromPreview: true, value: false},
			{name: "printOrientation", formerName: "Orientation", omitFromPreview: true, value: ""},
			{name: "printPaper", formerName: "PaperSize", omitFromPreview: true, value: ""},
			{name: "printFontScale", omitFromPreview: true, value: 100},
			{name: "querySize", formerName: "PageSize", personalized: true, value: 0},
			{name: "showCountIfSuspended", value: true},
			{name: "showFileSizes", formerName: "ShowFileSizes", value: false},
			{name: "sortSettings", value: []},
			{name: "suspended", formerName: "Suspend", transient: true, value: false},
			{name: "suspendedRequireFilter", value: false}
		],

		/**
		 * @override
		 * migrate and convert columnGroupAttribute and rowGroupAttribute to group settings
		 */
		convertToRuntimeValues(persistedValues, runtimeValues, localStorageParams) {
			if ((persistedValues.columnGroupAttribute !== null || persistedValues.ColumnGroupAttribute != null) && this.versionOnNode < CustomViewVersion.V791 ) {
				persistedValues.groupSettings = {};
			}

			this.inherited(arguments);
		},

		_groupHeaderStyleLoad: function(value, options, mapKey) {
			// summary: change value for views that reference old way of storing header style (as boolean)
			if (value === true) {
				return constants.GALLERY_HEADERS_PER_GROUP;
			} else if (value === false) {
				return "";
			}

			return value;
		},

		_groupSettingsLoad: function(value, options, mapKey) {
			// summary: convert persisted value into runtime option value
			let groupSettings = migrateGalleryViewGroupSettingsV1(options);
			if (groupSettings.key1 || groupSettings.key2) {
				groupSettings = {
					...groupSettings,
					key1: mapKey(groupSettings.key1),
					key2: mapKey(groupSettings.key2),
				}
			}

			return groupSettings;
		},
	});
});